import styled from 'styled-components';

export const LandingWrapper = styled.div``;
